module.exports = __webpack_public_path__ + "static/media/plus.b03ae4ab.svg";